import { render, staticRenderFns } from "./FooterFront.vue?vue&type=template&id=fa7e61ca"
import script from "./FooterFront.vue?vue&type=script&lang=js"
export * from "./FooterFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports